import React from 'react'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'

import withUser from '../hoc/withUser'

const validateDisabledRoute = disable => disable
const validateLoggedUser = auth => !Object.keys(auth).length
const validateUserPermissions = (auth, permit) => permit && !auth.permisos.some(permiso => permiso.clave === permit)
const validateAllowedParams = (validParams, params) => validParams && !validParams.includes(params)

const PrivateRoute = ({
  auth,
  component: Component,
  componentsByRole,
  permit,
  validParams,
  param,
  disable,
  ...rest }) => {

  const actualParam = useRouteMatch(rest.path).params[param];
const invalidRoute = false;
 /* const invalidRoute = validateDisabledRoute(disable)
      || validateLoggedUser(auth)
      || validateUserPermissions(auth, permit)
      || validateAllowedParams(validParams, actualParam)*/

  if (invalidRoute) {
    return <Redirect to="/" />
  }

  let FinalComponent = Component
  if (componentsByRole && auth.roles && auth.roles.length > 0) {
    const userRole = auth.roles[0]
    FinalComponent = componentsByRole[userRole] || Component
  }

  return <Route {...rest} render={props => <FinalComponent {...props} />} />
}

export default withUser(PrivateRoute)
